import { render } from "./PdfTemplate.vue?vue&type=template&id=0016f6bd"
import script from "./PdfTemplate.vue?vue&type=script&lang=js"
export * from "./PdfTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__